import { type Form, Switch } from 'antd';
import { Item } from './Item';

type ItemP = Omit<React.ComponentProps<typeof Form.Item>, 'children' | 'label'> & {
  label?: string;
  hidden?: boolean;
};

type InputP = Omit<React.ComponentProps<typeof Switch>, 'css'> & {
  'data-test-id'?: string;
  'aria-label'?: string; // This is missing from antd, similar to other HTML properties
};

type P = {
  item: ItemP;
  input?: InputP;
};

const SwitchInput = ({ item, input }: P) => {
  return (
    <Item {...item} valuePropName="checked">
      <Switch {...input} />
    </Item>
  );
};

export default SwitchInput;
